import { Exception } from './Exception'

export class CanceledException extends Exception {
  constructor() {
    super({
      message: 'Request cancelled',
      cause: {
        errors: [{ property: 'CanceledError', message: 'Request cancelled' }],
      },
    })
  }
}
